import React from "react";
import { BrowserRouter } from "react-router-dom";
import {
  AuthAdministradorRouter,
  AuthConductorRouter,
  AuthPasajeroRouter,
  PublicRouter,
} from "./router";
import { SinConexionAInternet } from "./pages/Public/SinConexionAInternet";

export default function App() {
  return (
    <BrowserRouter>
      <PublicRouter></PublicRouter>
      <AuthAdministradorRouter></AuthAdministradorRouter>
      <SinConexionAInternet></SinConexionAInternet>
      <AuthPasajeroRouter></AuthPasajeroRouter>
      <AuthConductorRouter></AuthConductorRouter>
    </BrowserRouter>
  );
}
